export default __webpack_public_path__ + "static/footer-logo-a71867473fb9614480ec346d5cadf88a.png";